import React from 'react';
import { Link } from 'react-router-dom';
import {FormattedMessage} from 'react-intl';

import url from '../../url-service';
import { convertToDate } from '../utils';
import m from '../../components/admin/tools/messages';


export default {
  categories: {
    titles: ['Categories', 'Tools'],
    getCellItems: (item) => {
      if (!item) return null;
      const { path, title } = item;
      return (
        <div className='table__col'>
          <Link to={url.createPath('category', path)}>{title}</Link>
        </div>
      )
    }
  },

  boards: {
    titles: ['Boards', 'Posts', 'Last Post', 'Tools'],
    getCellItems: (item) => {
      if (!item) return null;
      const { path, title, messages, lastPost } = item;
      return (
        <>
          <div className='table__col'>
            <Link to={url.createPath('category', path)}>{title}</Link>
          </div>
          <div className='table__col'>{messages}</div>
          <div className='table__col'>{lastPost && convertToDate(lastPost)}</div>
        </>
      )
    }
  },

  authors: {
    titles: ['Authors', 'Posts', 'Tools'],
    getCellItems: (item) => {
      if (!item) return null;
      const { userId, username } = item;
      return (
        <>
          <div className='table__col'>
            <a href={url.createPath('profile', userId)}>{username}</a>
          </div>
          <div className='table__col'>
            <button
              type='button'
              className='menu-nav__item-btn-link'
              onClick={() => location.href = `/boards/author-posts/${userId}`}
            >
              <FormattedMessage {...m.viewPosts} />
            </button>
          </div>
        </>
      )
    }
  },
  threads: {
    titles: ['Threads', 'Replies', 'Last Post', 'Tools'],
    getCellItems: (item) => {
      if (!item) return null;
      const { subject, path, id, repliesCount, lastPost } = item;
      return (
        <>
          <div className='table__col'>
            <Link to={url.createPath('thread', path, id)}>{subject}</Link>
          </div>
          <div className='table__col'>{repliesCount}</div>
          <div className='table__col'>{lastPost && convertToDate(lastPost)}</div>
        </>
      )
    }
  }
}
